<template>
<v-form v-model="valid" :disabled="terminer">
    
    <v-container v-if="store.state.user.token&&groupe.find(g=>g==store.state.user.groupe)">
        
        <v-progress-linear  v-if="store.state.waiting"  color="antiquewhite" indeterminate></v-progress-linear>
         <v-sheet :elevation="10"  width="600" style="margin-top: 0.5em;" :disabled="terminer">
            <v-toolbar color="#008080" height="30"><v-toolbar-title>{{ $t('magasin') }}</v-toolbar-title></v-toolbar>
            <v-card-text>
                <v-row>
                    <v-col cols="12" md="4">
                    <v-combobox clearable :label="$t('magasin')" :items="itemMagasin" v-model="magasin" variant="outlined" density="compact"></v-combobox>
                    </v-col>
                    <v-col cols="12" md="4">
                        <v-text-field v-model="vendeur" :label="$t('vendeur')" :disabled="terminer" variant="outlined" density="compact"></v-text-field>
                    </v-col>
                    <v-col cols="12" md="4">
                        <LangSwitcher @selectedLocale="(langue)=>{language=langue=='nl'?{value:'nl',libelle:'Nederlands'}:{value:'fr',libelle:'Français'}}"></LangSwitcher>
                    </v-col>
                </v-row>
            </v-card-text>

        </v-sheet>
        <v-sheet :elevation="10"  width="600" :disabled="terminer" style="margin-top: 0.5em;">
            <v-toolbar color="#008080" height="30"><v-toolbar-title>{{ $t('ticket') }}</v-toolbar-title></v-toolbar>
            <v-card-text>
                <v-row>
                    <v-col cols="12" md="6">
                        <v-checkbox :label="$t('avec_ticket')" v-model="ticket" @change="sTicket=false"></v-checkbox>
                        <v-checkbox :label="$t('sans_ticket')" style="margin-top: -40px;" v-model="sTicket" @change="ticket=false"></v-checkbox>
                    </v-col>
                </v-row>
            </v-card-text>
        </v-sheet>
        <div v-if="sTicket||ticket">
        <v-sheet :elevation="10"  width="600" style="margin-top: 0.5em;" >
            <v-toolbar color="#008080" height="30"><v-toolbar-title>{{$t('articles')}}</v-toolbar-title></v-toolbar>
            <DialogReceptionFripe :terminer :ticket></DialogReceptionFripe>
            <v-table>
                <thead >
                    <tr >
                        <th>{{ $t('action') }}</th>
                        <th v-for="item in headers"
                            :key="item.name">{{ $t(`${item.title}`) }}
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr
                        v-for="item in store.state.articlesFripe.sort((a, b) => a.marque - b.marque)"
                                :key="item"
                    >
                        <td>
                            <v-btn-group
                            color="#b2d7ef"
                            density="comfortable">
                            <v-icon style="margin-top: 1em;" icon="$error"  color="error" @click="deleteDialog=true;supprimer(item)" :disabled="terminer"></v-icon>
                            </v-btn-group>
                        </td>
                        <td>{{ item.marque }}</td> 
                        <td>{{ item.grade }}</td>
                        <td>{{ item.composition }}</td>
                        <td>{{ item.sousFamille }}</td>
                        <td>{{ item.libCouleur }}</td>
                        <td>€{{ item.prixAchatHT }}</td>
                        <td>€{{ item.prixAchatOrigine }}</td>
                        <td><input type="text" :disabled="terminer" :value="item.qteCommande" style="text-align: center;" size="2" @change="modifier($event.target.value,item.id,'qteCommande')"> </td>
                        <td><ul ><li v-for="el in item.accessoires">{{ el }}</li></ul></td>
                        <td style="text-align: center;" size="2">€ {{ item.totalBrut }}</td>
                    </tr>
                    <tr>
                        <td><h6>{{ $t('total') }}</h6> </td>
                        <td v-for="i in 9"
                            :key="i">
                        </td>
                        <td><h6>€ {{sum(store.state.articlesFripe,"totalBrut")}}</h6></td>
                    </tr>
                    <tr>

                    </tr>
                </tbody>
            </v-table>
            <Supprimer v-model="deleteDialog" :itemtoDelete></Supprimer>
            
        </v-sheet>
        <v-sheet :elevation="10" :disabled="terminer">
            <v-card >
                <div class="text-center pa-4">
                    <v-file-input
                        accept="image/png, image/jpeg, image/bmp"
                        :label="$t('photos')"
                        variant="outlined"
                        multiple
                        placeholder="importer les photos"
                        prepend-icon="mdi-camera"
                        @change="selectFile($event.target.files)"
                    ></v-file-input>
                </div>
                <v-card v-if="store.state.photoLinks.exist" >
                    <table style="margin-bottom: 5px;" >
                        <tbody>
                            <tr> 
                                <td v-for="(el, index) in store.state.photoLinks.id">
                                    <v-icon style="margin-left: 5px;"  icon="$error"  color="error" @click="supprimerPhoto(el)"></v-icon>
                                    <button @click="imageDialog=true;getPhotos(el)" type="button" class="btn btn-outline-secondary btn-sm">Photo {{ index+1 }}</button>
                                </td>
                            </tr>
                        </tbody>
                    </table> 
                </v-card>
            </v-card>
        </v-sheet>
        <v-sheet :elevation="10"  width="600" :disabled="terminer" style="margin-top: 0.5em;">
            <v-toolbar color="#008080" height="30"><v-toolbar-title>{{ $t('bon_du') }} {{ date }}</v-toolbar-title></v-toolbar>
            <v-card-text>
                <v-row>

                    <v-col cols="12" md="6">
                        <v-text-field v-model="informations" :label="$t('ref_suivi')" variant="outlined" density="compact"></v-text-field>
                    </v-col>
                    <!-- <v-col cols="12" md="6"> -->
                        <div class="text-center pa-4">
                            <v-btn @click="getReceptions()"  color="#008080">
                                 {{ $t('receptions') }}
                            </v-btn>
                            <v-dialog
                                v-model="dialogReceptions"
                                width="auto"
                            >
                                <v-card
                                max-width="300"
                                prepend-icon="mdi-update"
                                :title="$t('receptions')"
                                >
                                <v-list :items="receptions"></v-list>
                                <template v-slot:actions>
                                    <v-btn
                                    class="ms-auto"
                                    text="Ok"
                                    color="#008080"
                                    @click="dialogReceptions = false"
                                    ></v-btn>
                                </template>
                                </v-card>
                            </v-dialog>
                        </div>
                    <!-- </v-col> -->
                </v-row>
            </v-card-text>
        </v-sheet>
       
        <v-sheet :elevation="10"  width="600" style="margin-top: 0.5em;">
            <v-toolbar color="#008080" height="30"><v-toolbar-title>{{ $t('client') }}</v-toolbar-title></v-toolbar>
            <v-tabs v-model="tab" bg-color="grey" height="30">
            <v-tab value="one" :disabled="terminer" @click="store.state.clients=[];creationClient=`nouveau_client`;affichageClient=false;firstname='';lastname='';telephone='';ville='';tiers='';email='';adresse='';codePostal='';pays=''">{{ $t('recherche_client') }} </v-tab>
            <v-tab value="two" :disabled="terminer"> {{ $t(`${creationClient}`) }}</v-tab>
            </v-tabs>               
            <v-card-text>
                <v-tabs-window v-model="tab">
                    <v-tabs-window-item value="one">
                        <form action="" @submit.prevent="getClients()">
                            <v-card >
                                <v-row style="margin-top: 5px;">
                                    <v-col cols="12" md="3">
                                        <v-text-field v-model="lastname" :label="$t('nom')" variant="outlined" density="compact"></v-text-field>
                                    </v-col>
                                    <v-col cols="12" md="3">
                                        <v-text-field v-model="firstname" :label="$t('prenom')" variant="outlined" density="compact"></v-text-field>
                                    </v-col>
                                    <v-col cols="12" md="3">
                                        <v-text-field v-model="telephone" :label= "$t('telephone')" variant="outlined" density="compact"></v-text-field>
                                    </v-col>
                                    <v-col cols="12" md="3">
                                        <v-text-field v-model="ville" :label="$t('ville')" variant="outlined" density="compact"></v-text-field>
                                    </v-col>
                                </v-row>
                                <v-row style="margin-top: -20px;" justify="center">
                                    <v-col cols="12" md="4">
                                        <v-btn v-if="telephone||lastname||firstname" 
                                            style="margin-bottom: 2em;" :disabled="terminer"
                                            :loading="loading" block color="#008080"
                                            @click="loading = true;affichageClient=true"
                                            type="submit">
                                                {{ $t('rechercher') }}
                                            <v-progress-linear indeterminate ></v-progress-linear>
                                        </v-btn>
                                    </v-col>
                                </v-row>
                                <v-row  style="margin-top: -20px;margin-bottom: 10px;" v-if="affichageClient" >
                                        <v-list-item link v-for="(item, i) in store.state.clients" :key="i" width="600px"  @click="choixClient(item);affichageClient=false;creationClient=`modifier_client`">
                                                <v-icon icon="mdi-account" :style="[item&&item.t_email?{color:'green'}:{color:'red'}]"></v-icon>
                                                <v-chip style="margin-left: -20px;"  size="small" class="ml-2">
                                                {{ item?(`${item.t_libelle} - ${item.t_prenom} - ${item.t_telephone} - ${item.t_ville} - ${item.t_email?item.t_email:'Pas d’email'} - ${item.t_pays?item.t_pays.substring(0,2):''}`).substring(0,78):'' }}
                                            </v-chip>
                                        </v-list-item>
                                </v-row>
                            </v-card> 
                        </form>
                    </v-tabs-window-item>

                    <v-tabs-window-item value="two" id="element-to-convert2">
                        <v-card>
                            <v-row style="margin-top: -30px;">
                                <v-col cols="12" md="3">
                                    <v-checkbox :label="$t('madame')" v-model="mme" @change="mr=false" style="margin-left: 1em;"></v-checkbox>
                                </v-col>  
                                <v-col cols="12" md="3">     
                                    <v-checkbox :label="$t('monsieur')" v-model="mr" @change="mme=false"></v-checkbox> 
                                </v-col>
                                
                            </v-row>
                            <v-row>

                            </v-row>
                            <v-row style="margin-top: -40px;">
                                <v-col  cols="12" md="4">
                                    <v-text-field  v-model="firstname" :label="$t('prenom')" variant="outlined" density="compact"></v-text-field>
                                </v-col>

                                <v-col cols="12" md="4" >
                                    <v-text-field v-model="lastname" :label="$t('nom')" variant="outlined" density="compact"></v-text-field>
                                </v-col>

                                <v-col cols="12" md="4">
                                    <v-text-field variant="outlined" density="compact"
                                        v-model="birdhDay"
                                        :label="$t('date_naissance')"
                                        type="date"
                                    ></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row style="margin-top: -20px;">
                                <v-col cols="12"  md="4">
                                    <v-text-field v-model="telephone" :label="$t('telephone')" variant="outlined" density="compact"></v-text-field>
                                </v-col> 
                                <v-col cols="12" md="8">
                                    <v-text-field v-model="email" label="E-mail" variant="outlined" density="compact" ></v-text-field>
                                </v-col> 
                                
                            </v-row>
                          
                            <v-row style="margin-top: -20px;">
                                <v-col cols="12"  md="4">
                                    <v-combobox clearable v-model="pays" :label="$t('pays')" :items="itemsPays" variant="outlined" density="compact"></v-combobox>
                                    <!-- <v-text-field v-model="pays" label="Pays"></v-text-field> -->
                                </v-col> 
                                <v-col cols="12"  md="4">
                                    <v-text-field v-model="codePostal" :label="$t('code_postal')" variant="outlined" density="compact"></v-text-field>
                                </v-col> 
                                <v-col cols="12" md="4">
                                    <v-text-field v-model="ville" :label="$t('ville')" variant="outlined" density="compact"></v-text-field>
                                </v-col> 
                            </v-row>
                            <v-row style="margin-top: -20px;">
                                <v-col cols="12"  md="12">
                                    <v-text-field v-model="adresse" :label="$t('adresse')" variant="outlined" density="compact"></v-text-field>
                                </v-col> 

                            </v-row>
                            <v-row style="margin-top: -20px;" justify="center">
                                <v-col cols="12"  md="4" style="justify-content: center;">
                                    <v-btn block color="#008080"  :disabled="terminer||libelleAjout==`modifier`||libelleAjout==`ajoute`"
                                        @click="(libelleAjout==`modifier`?validerClient():addClient());(libelleAjout=libelleAjout==`modifier`?`modifie`:`ajoute`)">
                                        {{$t(`${libelleAjout}`) }}            
                                    </v-btn>
                                </v-col> 
                            </v-row>
                            
                            
                        </v-card> 
                       
                    </v-tabs-window-item>
                </v-tabs-window>
            </v-card-text>
        </v-sheet>
        <v-sheet :elevation="10"  width="600" style="margin-top: 0.6em;" >
            <v-toolbar color="#008080" height="30"><v-toolbar-title>{{ $t('signature') }}</v-toolbar-title></v-toolbar>
            <!-- <v-row justify="center">
                <v-col cols="12" md="8">
                    <v-btn @click="signature=!signature"  block  color="#008080"  style="margin-top: 0.5em;" v-if="!store.state.signature.exist">{{ $t('signature') }}</v-btn>
                </v-col>
            </v-row> -->
            <v-card   style="margin-top: 0.5em;" >
                <p style="margin: 0.5em;">{{ $t('je_sousigne') }}{{firstname}} {{lastname}}{{ $t('certificat_transfert') }}</p>
                <p style="margin: 0.5em;">{{ $t('ceder_propriete') }}</p>
                <h6 style="margin: 0.5em;color:red">{{ $t('signature') }}:</h6>
                <v-row>
                    <v-checkbox :label="$t('retour_article')" v-model="choixReprise1" @change="choixReprise2=false;choixReprise='reprendre'" style="margin-left: 1em;"></v-checkbox>
                </v-row>
                <v-row style="margin-top: -40px ;">
                    <v-checkbox :label="$t('don_association')" @change="choixReprise1=false;choixReprise='association'" style="margin-left: 1em;"></v-checkbox> 
                </v-row>
                <div class="text-center pa-4" v-if="!store.state.signature.exist">
                    <v-card elevation="16" >
                        <Signature  ></Signature>
                    </v-card>
                    
                </div>
                
                <div class="text-center pa-4" v-if="store.state.signature.exist">
                    <v-card elevation="16" >
                        <img class="fit-picture" :src="store.state.signature.link"></img>
                    </v-card>
                </div>
                
            </v-card>

        </v-sheet>
        <v-sheet :elevation="10"  width="600" style="margin-top: 0.8em;" height="330px">
            <v-toolbar color="#008080" height="30"><v-toolbar-title>{{ $t('validation') }}</v-toolbar-title></v-toolbar>
            <!-- <div class="text-center pa-8"> -->
                <v-row justify="center" style="margin-top: 10px;">
                    <v-col cols="12" md="8">
                        <v-text-field   v-model="email" label="E-mail" variant="outlined" density="compact"></v-text-field> 
                    </v-col>
                </v-row>
                
                <v-row style="margin-top: -20px;" justify="center">
                    <v-col cols="12" md="8">
                        <v-combobox v-model="language" :label="$t('langue_client')" item-title="libelle"  
                        item-value="value" :items="[{value:'fr',libelle:'Français'},{value:'nl',libelle:'Nederlands'}]" 
                        variant="outlined" density="compact" 
                        ></v-combobox>
                    </v-col>
                </v-row>
            <!-- </div> -->
            <!-- <div class="text-center"> -->
                <v-row justify="center">
                    <v-col cols="12" md="8">
                        <v-btn style="margin-top: -20px;" @click="validerArticles();dialogFinale=true;terminer=true"  block  color="success" :disabled="terminer||store.state.articlesFripe.length==0||!email||!store.state.signature.exist" >
                        {{ $t('valider') }}
                        </v-btn>
                    </v-col>
                </v-row>
            
                <v-dialog
                    v-model="dialogFinale"
                    width="auto"
                >
                    <v-card
                    max-width="400"
                    prepend-icon="mdi-update"
                    :text="`${$t('reception_num')} ${store.state.numeroBon} ${$t('reception_num_reste')}`"
                    :title="$t('verif_encours')"
                    >
                    <template v-slot:actions>
                        <v-btn
                        class="ms-auto"
                        text="Ok"
                        @click="dialogFinale = false"
                        ></v-btn>
                    </template>
                    </v-card>
                </v-dialog>
            <!-- </div> -->
            <!-- <v-btn @click="NouvelleReception()" block  color="warning" style="margin-bottom: 5em;">
                Nouvelle Reception
            </v-btn> -->
            <!-- <div class="text-center"> -->
                <v-row justify="center">
                    <v-col cols="12" md="8">
                        <v-btn @click="dialogNewReception=true" block  color="warning" style="margin-bottom: 5em;">
                            {{ $t('nouvelle_reception') }}
                        </v-btn>
                    </v-col>
                </v-row>
            
                <v-dialog
                    v-model="dialogNewReception"
                    width="auto"
                >
                    <v-card
                    max-width="400"
                    prepend-icon="mdi-update"
                    :text="$t('meme_client')"
                    :title="$t('nouvelle_reception')"
                    >
                    <template v-slot:actions>
                        
                        <v-btn
                        class="ms-auto"
                        :text="$t('non')"
                        color="red"
                        @click="NouvelleReception(false);dialogNewReception = false"
                        ></v-btn>
                        <v-btn
                        class="ms-auto"
                        :text="$t('oui')"
                        color="green"
                        @click="NouvelleReception(true);dialogNewReception = false"
                        ></v-btn>
                    </template>
                    </v-card>
                </v-dialog>
            <!-- </div> -->
                <!-- <v-btn @click="sendEmail()">
                    sendEmail
                </v-btn> -->
        </v-sheet>
        </div>
        
        
        <!-- <Pdf id="element-to-convert" :vendeur :magasin v-if="recap"></Pdf> -->
    </v-container>
  </v-form>
    <div class="text-center pa-4">
      <v-dialog v-model="imageDialog" width="600">
        <v-card width="600">
            <v-img
                width="600"
                cover
                :src="srcImage"
            ></v-img>
        </v-card>
      </v-dialog>
    </div>
</template>
<script setup>
import { onMounted, ref} from 'vue'
import store from './store'
import DialogReceptionFripe from './DialogReceptionFripe.vue'
import Supprimer from './Supprimer.vue'
import axios from 'axios'
import Signature from './Signature.vue'
import LangSwitcher from './components/LangSwitcher.vue'
import { useI18n } from 'vue-i18n'
const { t } = useI18n()
let sTicket=ref(false)
let ticket=ref(false)
let dialogFinale=ref(false)
let dialogReceptions=ref(false)
let dialogNewReception=ref(false)
let receptions=ref()
let srcImage=ref()
let imageDialog=ref(false)
const date = new Date(Date.now()).toLocaleString().split(' ')[0];
let terminer=ref(false)
let photo=ref(false)
let signature=ref(false)
let affichageClient=ref(true)
let creationClient=ref(`nouveau_client`)
let informations=ref()
let valid=ref()
let vendeur=ref()
let tab=ref(null)
let choixReprise1=ref(null)
let choixReprise2=ref(null)
let firstname=ref()
let language=ref({value:store.state.user.language,libelle:`${store.state.user.language.match(/'nl'/gmi)?'Nederlands':'Français'}`})
let lastname=ref()
let telephone=ref()
let ville=ref()
let tiers=ref()
let libelleAjout=ref('ajouter')
let email=ref()
let birdhDay=ref()
let adresse=ref()
let codePostal=ref()
let pays=ref()
let magasin=ref(store.state.user.etablissement)
let mme=ref(false)
let mr=ref(false)
let choixReprise=ref()
let groupe=ref(['A','B','C'])
let deleteDialog=ref()
let loading=ref(false)
let itemMagasin=ref([``,'MN01','DK03','EN11','FT04','LI02','RO06','AR09','CO18','HB21','BR08','OO10','NP19','GE22'])

let itemsPays=ref(['France','Belgique','Pays Bas','Luxembourg','Espagne','Suisse'])
const validerClient=()=>{
    store.state.clients=store.state.clients
}
let files=ref([])

const selectFile=(event)=>{

    for (let i=0;i<event.length; i++){
        files.value.push(event[i])
        addImages(event[i])
    }    


}

let rulesPhotos=ref([
    // value => {
    //   return !value || !value.length || value[0].size < '20mb' || 'Avatar size should be less than 2 MB!'
    // },
  ])
let rules1=()=>{

    if(email.value.toString().match(/^[a-z.-]+@[a-z.-]+\.[a-z]+$/i)){
        // valid.value=true
        return [true]
    } else{
        // valid.value=false
        return [`L'email n'est pas en bon format`]
    }
}
// let valid=ref(false)
let headers=ref([
    { key: 'marque',title:  'marque'},
    { key: 'grade', title:  'grade' },
    { key: 'composition', title:  'composition' },
    { key: 'sousFamille', title:  'sous_famille' },
    { key: 'libCouleur', title:  'couleur' },
    { key: 'prixAchatHT', title:  'prix_reprise' },
    { key: 'prixAchatOrigine', title:  'prix_origine' },
    { key: 'qteCommande', title:  'qte' },
    { key: 'accessoires', title:  'accessoires' },
    { key: 'totalBrut', title:  'total' } 
    ]) 
    // const filen = document.getElementById("fileItem").files[0];
const NouvelleReception=(oui)=>{
    if(!oui){
        affichageClient.value=true
        creationClient.value=`nouveau_client`
        informations.value=''
        valid.value=''
        vendeur.value=''
        tab.value=null
        firstname.value=''
        language.value={value:store.state.user.language,libelle:`${store.state.user.language.match(/'fr'/gmi)?'Français':'Nederlands'}`}
        lastname.value=''
        telephone.value=''
        ville.value=''
        tiers.value=''
        libelleAjout.value=`ajouter` 
        email.value=''
        birdhDay.value=''
        adresse.value=''
        codePostal.value=''
        pays.value=''
        mme.value=false
        mr.value=false
        store.commit('addClient',[]) 
    }
    terminer.value=false
    ticket.value=false
    sTicket.value=false
    tab.value="one"
    photo.value=false
    signature.value=false

    choixReprise2.value=false
    choixReprise1.value=false
    store.commit('updatephoto',true)
    store.commit('deleteArticles')
    store.commit('addSignature',{exist:false,link:''})
    store.commit('deletePhotos',{exist:false,link:[],id:[]})
}
let file=ref()
const handleFileUpload=( event )=>{
  file.value = event.target.files[0];
}


const choixClient=(item)=>{
    libelleAjout.value=`modifier`
    tab.value="two"
    store.state.clients=item
    firstname.value=item.t_prenom
    lastname.value=item.t_libelle
    telephone.value=item.t_telephone
    ville.value=item.t_ville
    tiers.value=item.t_tiers
    email.value=item.t_email
    adresse.value=item.t_adresse1
    codePostal.value=item.t_codepostal
    pays.value=item.t_pays
    // magasin.value=item.T_ETABLISSEMENT
}
const modifier=(value,id,champs)=>{
    store.commit('editRowArticle',{'value':value,'id':id,'champs':champs})
}
let itemtoDelete=ref()
const supprimer=(item)=>{
    itemtoDelete=item
}

let sum=(object,value)=>{
  let sum=0
//   //console.log(object,value);
  
  for(let key in object){
    sum=sum+(object[key][value]?Number(object[key][value]):0)
  } 
  return sum
 }
 
async  function validerArticles(){
    await getNumBon()
    sendImages()
    let data = { 
        title:magasin.value+'-'+store.state.numeroBon,
        reception:{
            etablissement:magasin.value,
            vendeur:vendeur.value,
            numeroBon:store.state.numeroBon,
            etat:'encours',informations:informations.value,
            vendeur:vendeur.value,choixReprise:choixReprise.value,
            type:'SL',
            ticket:ticket.value,
            prenom:firstname.value,
            language:language.value.value},
        articles:store.state.articlesFripe,
        client:{
            "tiers":tiers.value,
            "firstname":firstname.value,
            "lastname":lastname.value,
            "email":email.value,
            "telephone":telephone.value,
            "telex":telephone.value,
            "adesse":adresse.value,
            "codePostal":codePostal.value,
            "ville":ville.value,
            "pays":pays.value,
            "sexe":mme||mr?mme?'MMme':'MR':'',
            "choixReprise":choixReprise.value,
            "magasin": magasin.value
        },
        photos:{
            photos:store.state.photoLinks.id
        },
        termine:false,
        token:store.state.user.token,
        user:store.state.user
        
    }
    // console.log(data);
        
    let config = {
    method: 'post',
    maxBodyLength: Infinity,
    url: 'https://my.edisac.com/api/recordsfripe',
    // url: 'http://localhost:8282/apimyedisac/recordsfripe',
    headers: { 
        'Content-Type': 'application/json'
    },
    data : data
    }
    // console.log('data send');
    loading.value=false
    return axios.request(config)
    .then((response) => { 
        // console.log(response);
        
    })
    .catch((error) => {
    //console.log(error);
    });
 }

    async function getClients(){   
        let chlibelle=lastname.value?'&libelle='+lastname.value:''
        let chprenom=firstname.value?'&prenom='+firstname.value:''
        let chetablissement='&etablissement='
        let chemail=email.value?'&email='+email.value:''
        let chtelephone=telephone.value?'&telephone='+telephone.value:''
        let chcodepostal=codePostal.value?'&codepostal='+codePostal.value:''
        let chville=ville.value?'&ville='+ville.value:''
        let chpays='&pays='
        let url=    `https://my.edisac.com/api/clients`+`?${tiers.value?'tiers='+tiers.value:''}`+`${chlibelle.replace('libelle=,','libelle=').trim()}`+`${chprenom.replace('prenom=,','prenom=').trim()}`+`${chetablissement.replace('etablissement=,','etablissement=').trim()}`+`${chemail.replace('email=,','email=').trim()}`+`${chtelephone.replace('telephone=,','telephone=').trim()}`+`${chcodepostal.replace('codepostal=,','codepostal=').trim()}`+`${chville.replace('ville=,','ville=').trim()}` +`${chpays.replace('pays=,','pays=').trim()}`
        // console.log(url);
        
        let config = {
        method: 'get',
        url: url
        };
        return   axios.request(config)
        .then((response) => {
            // console.log(response.data);
            
            store.commit('addClient',response.data) 
            loading.value=false   
        })
        .catch((error) => {
        //console.log(error);
        });

    }
    const sendImages=()=>{
        // console.log({image:photo});
        
        let data = {
            reception:magasin.value+'-'+store.state.numeroBon,
            signature:store.state.signature.link,
            photos:store.state.photoLinks
        }
        let config = {
        method: 'post',
        maxBodyLength: Infinity,
        url: 'https://my.edisac.com/api/upload',
        headers: { 
            'Content-Type': 'application/json'
        },
        data : data
        }
        return axios.request(config)
        .then((response) => { 
            // console.log(response);
            
        })
        .catch((error) => {
        //console.log(error);
        });
    }
    async function addImages(event){
        //console.log(event);
        const formData = new FormData();
        formData.append('file', event);
        let config = {
        method: 'post',
        maxBodyLength: Infinity,
        url: 'https://my.edisac.com/api/uploadphotos',
        headers: { 
            'Content-Type': 'multipart/form-data'
        },
        data:formData 
        }
        return axios.request(config)
        .then((response) => { 
            //console.log(response);

            store.commit('addPhotos',{exist:true,link:response.data.file,id:response.data.file})
            
        })
        .catch((error) => {
        //console.log(error);
        });
    }

    async function getReceptions(){  
    let url=    `https://my.edisac.com/api/receptions`
    // console.log(magasin.value)
    let config = {
    method: 'get',
    url: url,
    params:{finished:'false',inprogress:'true',magasin:magasin.value}
    };
    return   axios.request(config)
    .then((response) => {
        receptions.value=response.data.data.sort((a,b)=>{return b.num_reception-a.num_reception}).map(item => {
            return {
                ...item,
                title: item.etablissement + "-" + item.num_reception + "-" + item.statut
            };
        })
        dialogReceptions.value=true
    })
    .catch((error) => {
    //console.log(error);
    });
}


async function addClient(){
    let data = JSON.stringify({
        firstname:firstname.value,
        lastname:lastname.value,
        email:email.value,
        telephone:telephone.value,
        telex:telephone.value,
        adesse:adresse.value,
        codePostal:codePostal.value,
        ville:ville.value,
        pays:pays.value,
        sexe:mme||mr?mme?'MMme':'MR':'',
        magasin:magasin.value,
        choixReprise:choixReprise1?'reprendre':'association'
    });



    let config = {
    method: 'post',
    maxBodyLength: Infinity,
    url: 'https://my.edisac.com/api/client',
    headers: { 
        'Content-Type': 'application/json'
    },
    data : data
    }
    // loading.value=false
    return axios.request(config)
    .then((response) => { 
        tiers.value=response.data.tiers

    })
    .catch((error) => {
    //console.log(error);
    });
}
let emailStatus=ref({
    email:email,
    status:true,
    message:'Email Validé'
})
async function verifierEmail(email) {
  
    let config = {
    method: 'get',
    maxBodyLength: Infinity,
    url: `https://rapid-email-verifier.fly.dev/api/validate?email=${encodeURIComponent(email)}`,
    headers: { }
    };

    axios.request(config)
    .then((response) => {
    console.log(JSON.stringify(response.data));
        if(response.data.status=='VALID'){
            emailStatus.value= {
                email:email,
                status:true,
                message:'Email Validé'
            }
        }else{
            emailStatus= {
                email:email,
                status:false,
                message:'L’adresse e-mail n’existe pas'
            }
        }
    })
    .catch((error) => {
    console.log(error);
    });
}
async function getNumBon(){  
    let url=    `https://my.edisac.com/api/numbon`
    let config = {
    method: 'get',
    url: url
    };
    return   axios.request(config)
    .then((response) => {
        store.commit('addNumBon',response.data)
        // sendNumBon()
    })
    .catch((error) => {
    //console.log(error);
    });
}
const supprimerPhoto=(el)=>{
    store.commit('deletePhoto',el)
}
async function getPhotos(el){

    let config = {
    method: 'get',
    maxBodyLength: Infinity,
    url: 'https://my.edisac.com/api/getphoto',
    headers: { 
        'Content-Type': 'application/json'
    },
    params : {photo:el}
    }

    return axios.request(config)
    .then((response) => { 
        srcImage.value=response.data
        
    })
    .catch((error) => {
    //console.log(error);
    });
}

</script>
<style>
.fit-picture {
  text-align: center;
  width: 350px;
  height: 200px
}
.photo {
    color:blue;
    cursor: pointer;
}
.photo:hover{
    background-color: lightgrey
}
</style>